module.exports = __webpack_public_path__ + "img/law.4d31d4db.jpg";